// Country name to ISO code mapping
export const COUNTRY_NAME_TO_CODE = {
    // Common countries
    'United States': 'US',
    'Canada': 'CA',
    'United Kingdom': 'GB',
    'Australia': 'AU',
    'India': 'IN',
    'China': 'CN',
    'Japan': 'JP',
    'Germany': 'DE',
    'France': 'FR',
    'Italy': 'IT',
    'Spain': 'ES',
    'Mexico': 'MX',
    'Brazil': 'BR',
    'Argentina': 'AR',
    'Chile': 'CL',
    'Colombia': 'CO',
    'Peru': 'PE',
    'Venezuela': 'VE',
    'Ecuador': 'EC',
    'Bolivia': 'BO',
    'Paraguay': 'PY',
    'Uruguay': 'UY',
    'Costa Rica': 'CR',
    'Panama': 'PA',
    'Guatemala': 'GT',
    'Honduras': 'HN',
    'Nicaragua': 'NI',
    'El Salvador': 'SV',
    'Cuba': 'CU',
    'Dominican Republic': 'DO',
    'Haiti': 'HT',
    'Jamaica': 'JM',
    'Trinidad and Tobago': 'TT',
    'Bahamas': 'BS',
    'Barbados': 'BB',
    'Grenada': 'GD',
    'Saint Lucia': 'LC',
    'Saint Vincent and the Grenadines': 'VC',
    'Andorra': 'AD',
    'Antigua and Barbuda': 'AG',
    'Dominica': 'DM',
    'Saint Kitts and Nevis': 'KN',
    'Russia': 'RU',
    'Ukraine': 'UA',
    'Poland': 'PL',
    'Romania': 'RO',
    'Netherlands': 'NL',
    'Belgium': 'BE',
    'Czech Republic': 'CZ',
    'Greece': 'GR',
    'Portugal': 'PT',
    'Sweden': 'SE',
    'Hungary': 'HU',
    'Austria': 'AT',
    'Switzerland': 'CH',
    'Bulgaria': 'BG',
    'Denmark': 'DK',
    'Finland': 'FI',
    'Slovakia': 'SK',
    'Norway': 'NO',
    'Ireland': 'IE',
    'Croatia': 'HR',
    'Bosnia and Herzegovina': 'BA',
    'Serbia': 'RS',
    'Lithuania': 'LT',
    'Slovenia': 'SI',
    'Latvia': 'LV',
    'Estonia': 'EE',
    'North Macedonia': 'MK',
    'Albania': 'AL',
    'Malta': 'MT',
    'Luxembourg': 'LU',
    'Montenegro': 'ME',
    'Iceland': 'IS',
    'South Africa': 'ZA',
    'Nigeria': 'NG',
    'Egypt': 'EG',
    'Kenya': 'KE',
    'Ethiopia': 'ET',
    'Ghana': 'GH',
    'Tanzania': 'TZ',
    'Uganda': 'UG',
    'Algeria': 'DZ',
    'Sudan': 'SD',
    'Morocco': 'MA',
    'Angola': 'AO',
    'Mozambique': 'MZ',
    'Madagascar': 'MG',
    'Cameroon': 'CM',
    'Ivory Coast': 'CI',
    'Niger': 'NE',
    'Burkina Faso': 'BF',
    'Mali': 'ML',
    'Malawi': 'MW',
    'Zambia': 'ZM',
    'Senegal': 'SN',
    'Somalia': 'SO',
    'Chad': 'TD',
    'Zimbabwe': 'ZW',
    'Guinea': 'GN',
    'Rwanda': 'RW',
    'Benin': 'BJ',
    'Tunisia': 'TN',
    'South Sudan': 'SS',
    'Togo': 'TG',
    'Sierra Leone': 'SL',
    'Libya': 'LY',
    'Liberia': 'LR',
    'Mauritania': 'MR',
    'Central African Republic': 'CF',
    'Eritrea': 'ER',
    'Gambia': 'GM',
    'Botswana': 'BW',
    'Namibia': 'NA',
    'Gabon': 'GA',
    'Lesotho': 'LS',
    'Guinea-Bissau': 'GW',
    'Equatorial Guinea': 'GQ',
    'Mauritius': 'MU',
    'Eswatini': 'SZ',
    'Djibouti': 'DJ',
    'Comoros': 'KM',
    'Cape Verde': 'CV',
    'Sao Tome and Principe': 'ST',
    'Seychelles': 'SC',
    'Pakistan': 'PK',
    'Bangladesh': 'BD',
    'Philippines': 'PH',
    'Vietnam': 'VN',
    'Thailand': 'TH',
    'South Korea': 'KR',
    'Myanmar': 'MM',
    'Afghanistan': 'AF',
    'Iraq': 'IQ',
    'Saudi Arabia': 'SA',
    'Uzbekistan': 'UZ',
    'Malaysia': 'MY',
    'Nepal': 'NP',
    'Yemen': 'YE',
    'North Korea': 'KP',
    'Sri Lanka': 'LK',
    'Kazakhstan': 'KZ',
    'Syria': 'SY',
    'Cambodia': 'KH',
    'Jordan': 'JO',
    'Azerbaijan': 'AZ',
    'United Arab Emirates': 'AE',
    'Tajikistan': 'TJ',
    'Israel': 'IL',
    'Hong Kong': 'HK',
    'Laos': 'LA',
    'Singapore': 'SG',
    'Lebanon': 'LB',
    'Kyrgyzstan': 'KG',
    'Turkmenistan': 'TM',
    'Palestine': 'PS',
    'Oman': 'OM',
    'Kuwait': 'KW',
    'Georgia': 'GE',
    'Mongolia': 'MN',
    'Armenia': 'AM',
    'Qatar': 'QA',
    'Bahrain': 'BH',
    'East Timor': 'TL',
    'Cyprus': 'CY',
    'Bhutan': 'BT',
    'Macau': 'MO',
    'Brunei': 'BN',
    'Maldives': 'MV',
    'Indonesia': 'ID',
    'Turkey': 'TR',
    'Iran': 'IR',
    'New Zealand': 'NZ',
    'Papua New Guinea': 'PG',
    'Fiji': 'FJ',
    'Solomon Islands': 'SB',
    'Vanuatu': 'VU',
    'Samoa': 'WS',
    'Kiribati': 'KI',
    'Tonga': 'TO',
    'Micronesia': 'FM',
    'Palau': 'PW',
    'Marshall Islands': 'MH',
    'Nauru': 'NR',
    'Tuvalu': 'TV',
};

// Reverse mapping: ISO code to country name
export const COUNTRY_CODE_TO_NAME = Object.entries(COUNTRY_NAME_TO_CODE).reduce(
    (acc, [name, code]) => {
        acc[code] = name;
        return acc;
    },
    {}
);

/**
 * Convert country name to ISO code
 * @param {string} countryName - Full country name
 * @returns {string} - 2-letter ISO code (or first 2 letters if not found)
 */
export function countryNameToCode(countryName) {
    if (!countryName) return '';
    const trimmed = countryName.trim();
    return COUNTRY_NAME_TO_CODE[trimmed] || trimmed.substring(0, 2).toUpperCase();
}

/**
 * Convert ISO code to country name
 * @param {string} code - 2-letter ISO code
 * @returns {string} - Full country name (or the code itself if not found)
 */
export function countryCodeToName(code) {
    if (!code) return '';
    const upperCode = String(code).trim().toUpperCase();
    return COUNTRY_CODE_TO_NAME[upperCode] || code;
}
